import { Component, Input, Output, OnChanges, EventEmitter } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { RadioPrompt } from '../../../../../forms/models'
import { QuestionViewService, IQuestionAnswer } from '../../'

@Component({
  selector: 'mp-select-one-choice-view',
  templateUrl: './select-one-choice-view.html'
})
export class SelectOneChoiceViewComponent implements OnChanges {
  @Input() public answerChoicePrompt: RadioPrompt
  @Input() public formGroup: FormGroup

  @Output() public optionSelected: EventEmitter<IQuestionAnswer> = new EventEmitter()

  public reviewMode: boolean = false

  public constructor(
    private _questionViewService: QuestionViewService
  ) {}

  public ngOnChanges() {
    this.reviewMode = this._questionViewService.reviewMode
  }

  public selectOption(value) {
    if (this.reviewMode || this.formGroup.disabled) {
      return
     }
    this.formGroup.setValue({answerChoice: value})
    this.optionSelected.emit({choiceId: value, value: ''})
  }

  public isSelected(option) {
    return this.formGroup.value.answerChoice === option.value
  }

  public isCorrect(option): boolean {
    return this._questionViewService.question.isAnswerChoiceCorrect(option.value)
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/choice-views/select-one-choice-view/select-one-choice-view.component.ts